(() => {
  if (window.nceItemOwnershipStarted) return;
  window.nceItemOwnershipStarted = true;
  const origin = 'https://collection.nascardexchange.com';
  const records = new WeakMap();
  const pending = new Map();
  let frame, ready = false;
  function reset(record) {
    record.link.hidden = false;
    record.link.textContent = record.original.link;
    record.heading.textContent = record.original.heading;
    record.copy.textContent = record.original.copy;
    record.secondary.textContent = record.original.secondary;
    record.secondary.href = record.original.href;
    record.status.hidden = true;
  }
  function send(id,record) {
    frame.contentWindow.postMessage({type:'nce:ownership:check',requestId:id,product:record.product},origin);
  }
  function check(panel,refresh=false) {
    let record = records.get(panel);
    if (record && !refresh) return;
    if (!record) {
      const link = panel.querySelector('.nce-item-collect');
      const heading = panel.querySelector('h2');
      const copy = panel.querySelector('p');
      const secondary = panel.querySelector('.nce-item-collection-links a:not(.nce-item-collect)');
      if (!link || !heading || !copy || !secondary) return;
      const product = new URLSearchParams(new URL(link.href).hash.slice(1)).get('add-card');
      if (!product) return;
      const status = document.createElement('span');
      status.className = 'nce-item-owned'; status.setAttribute('role','status');
      link.before(status);
      record = {panel,link,heading,copy,secondary,status,product,original:{link:link.textContent,heading:heading.textContent,copy:copy.textContent,secondary:secondary.textContent,href:secondary.href}};
      records.set(panel,record);
    }
    if (record.requestId) {clearTimeout(pending.get(record.requestId)?.timer);pending.delete(record.requestId);}
    reset(record);
    record.link.hidden = true; record.status.hidden = false; record.status.textContent = panel.dataset.checkingLabel;
    const id = crypto.randomUUID(); record.requestId = id;
    const timer = setTimeout(()=>{if(pending.delete(id))reset(record);},10000);
    pending.set(id,{record,timer});
    if (!frame) {
      frame = document.createElement('iframe');frame.hidden = true;frame.title = 'Collection ownership check';
      frame.setAttribute('sandbox','allow-scripts allow-same-origin');frame.referrerPolicy = 'origin';
      frame.src = origin + '/storefront-ownership.html';document.body.append(frame);
    }
    if (ready) send(id,record);
  }
  window.addEventListener('message',event=>{
    if (event.origin !== origin || event.source !== frame?.contentWindow) return;
    if (event.data?.type === 'nce:ownership:ready') {ready=true;for(const [id,{record}] of pending)send(id,record);return;}
    if (event.data?.type !== 'nce:ownership:result') return;
    const item = pending.get(event.data.requestId);if(!item)return;
    pending.delete(event.data.requestId);clearTimeout(item.timer);
    const {record} = item;reset(record);
    if(event.data.authenticated === true && event.data.matched === true && event.data.owned === true){
      record.link.hidden = true;record.status.hidden = false;record.status.textContent = record.panel.dataset.ownedLabel;
      record.heading.textContent = record.panel.dataset.ownedHeading;record.copy.textContent = record.panel.dataset.ownedCopy;
      record.secondary.textContent = record.panel.dataset.viewLabel;record.secondary.href = record.link.href;
    }else if(event.data.authenticated === true){record.link.textContent = record.panel.dataset.addLabel;}
  });
  function scan(root,refresh=false) {
    if(root.matches?.('[data-nce-ownership]'))check(root,refresh);
    root.querySelectorAll?.('[data-nce-ownership]').forEach(panel=>check(panel,refresh));
  }
  scan(document);
  new MutationObserver(changes=>{for(const change of changes)for(const node of change.addedNodes)if(node.nodeType===1)scan(node);}).observe(document.body,{childList:true,subtree:true});
  // Returning from My Collection can restore this document or simply focus its tab.
  // Coalesce focus/visibility/pageshow so one return makes one fresh request.
  let returnTimer;
  function refreshOnReturn() {
    if (document.visibilityState === 'hidden') return;
    clearTimeout(returnTimer);
    returnTimer = setTimeout(()=>scan(document,true),100);
  }
  window.addEventListener('focus',refreshOnReturn);
  document.addEventListener('visibilitychange',refreshOnReturn);
  window.addEventListener('pageshow',event=>{if(event.persisted)refreshOnReturn();});
})();
